import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    console.log("UserFormController connected");
  }

  disableBlankPassword() {
    const passwordField = this.element.querySelector("[id$='_password']");
    if (passwordField && !passwordField.value) {
      passwordField.disabled = true;
    }
  }
}
